<app-codigoconfeccion-list 
    [result]="almacenes" [lastFilter]="payloadRecintosPIA"
    [mode]="recintoListMode" [readonly]="readonly" 
    (search)="onSearchLazy($event)" (view)="onViewHandler($event)" (delete)="onDeleteAlmacen($event)" (undoDelete)="onUndoDeleteAlmacen($event)">
</app-codigoconfeccion-list>

<!-- Ventana de diálogo para añadir Almacenes a la solicitud -->
<app-codigoconfeccion-list-dialog [visible]="recintoPIAListDialogVisible" [dialogFilter]="dialogFilter" (selectedAlmacenes)="onSelectedAlmacenes($event)"></app-codigoconfeccion-list-dialog>

<!-- Ventana para mostrar el detalle de un Almacén -->
<app-codigoconfeccion-detail-dialog [visible]="recintoPIADetailVisible" [Id]="recintoPIAIdSelected" (closed)="onAlmacenDialogClosed($event)"></app-codigoconfeccion-detail-dialog>
